import { render, staticRenderFns } from "./intelligentBody.vue?vue&type=template&id=5cb9867c&scoped=true"
import script from "./intelligentBody.vue?vue&type=script&lang=js"
export * from "./intelligentBody.vue?vue&type=script&lang=js"
import style0 from "./intelligentBody.vue?vue&type=style&index=0&id=5cb9867c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9867c",
  null
  
)

export default component.exports